import { render, staticRenderFns } from "./template05.vue?vue&type=template&id=48d59326&scoped=true&"
import script from "./template05.vue?vue&type=script&lang=js&"
export * from "./template05.vue?vue&type=script&lang=js&"
import style0 from "./template05.vue?vue&type=style&index=0&id=48d59326&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d59326",
  null
  
)

export default component.exports